import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

export enum Entity {
  Attributes = 1,
  Product,
  Issues,
}

export type AISuggestionTarget = 'taxonomy' | 'topic';
export type AISuggestionModalProps<T extends AISuggestionTarget> =
  T extends 'taxonomy'
    ? AISuggestionBaseProps<T> & {
        taxonomy: TaxonomyT;
      }
    : AISuggestionBaseProps<T> & {
        topic: Topic2T<TOPIC_2_TYPE>;
      };

export type AISuggestionBaseProps<T extends AISuggestionTarget> = {
  target: T;
  taxonomyAlias: string;
  targetAlias: string;
  targetName: string;
};

export const CHILD_TOPIC_SELECT_MODAL_KEY = 'CHILD_TOPIC_SELECT_MODAL_KEY';
